<template>
  <section v-loading.fullscreen.lock="loading">
    <div v-if="user.is_model_library===0" class="declare">
      <com-tabs
        v-if="tabs"
        :list="tabs"
        class="declare-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="declare-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>

      <div class="declare-content">
        <div v-show="activeTab == 0">
          <!-- :style="contentStyle()" -->
          <!-- <com-declare-apply
            v-if="submitState != 1"
            v-model="data2"
            :borrow-types="libraryInfo.data.borrowTypes"
            :train-types="libraryInfo.data.trainTypes"
            @input="init"
            @next="handleApplyNext"
          />
          <com-declare-score
            v-if="submitState == 1"
            :list="libraryInfo.data.data1"
            :borrow-types="libraryInfo.data.borrowTypes"
            :train-types="libraryInfo.data.trainTypes"
            :school-types="schoolTypes"
            :data1="data1"
            :data2="data5"
            :data3="data3"
            :data4="data4"
            :data5="data6"
            :state="state"
            :submit-state="submitState"
            @input="init"
          /> -->
          <UpPDF
            :pdf-data="pdfData"
            @callBack="getData"
          />
        </div>
        <com-declare-resource v-show="activeTab == 1" :state="state" />
      </div>
    </div>
    <div v-else class="declare">
      <Article />
    </div>
  </section>
</template>

<script>

import api from '@/api/app'
import {
  declareDataApi
} from '@/api/library.js'

import comTabs from '@/components/comTabs'
// import comDeclareApply from './details/comDeclareApply/index.vue'
// import comDeclareScore from './details/comDeclareScore/index.vue'
import comDeclareResource from './details/comDeclareResource/index.vue'
import UpPDF from './details/upPDF'
import Article from './details/article'

import mock from '@/utils/mock'
import { mapGetters } from 'vuex'
export default {
  name: 'ComDeclare',
  components: {
    comTabs,
    // comDeclareApply,
    // comDeclareScore,
    comDeclareResource,
    UpPDF,
    Article
  },
  props: {
    schoolTypes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    }),
    tabs: {
      get() {
        let tabs
        switch (this.state) {
          case 0:
            tabs = this.libraryInfo.obj.tabs
            break
          case 1:
            tabs = this.libraryInfo.obj.tabs1
            break
          default:
            tabs = null
        }
        return tabs
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  data() {
    return {
      loading: false,
      libraryInfo: mock.library.declare.viewInfo,
      libraryInit: mock.library.declare.init,
      activeTab: 0,
      state: null,
      submitState: 0,
      requestParams: {
        school_id: null
      },
      // tabs: mock.library.declare.viewInfo.obj.tabs,
      // data1: null, // 用户已提交数据 所生成的报告
      // data2: null // 用户已提交数据
      // data3: null, // 用户已上传 用于审核的图片
      // data4: null, // 用户已上传 用于审核的视频
      // data5: null, // 用户已提交的数据(已审核) 生成的软文
      // data6: null // 用户已上传 用于审核的报告,
      pdfData: {
        ApplySrc: '',
        DeclareSrc: '',
        status: ''
      }

    }
  },
  mounted() {
    // this.init()
    api.mine.retrieve.dto().then((v) => {
      this.$store.commit('user/setUser', v.data)
    })
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      declareDataApi().then((res) => {
        this.pdfData.ApplySrc = res.data.apply_url
        this.pdfData.DeclareSrc = res.data.declare_url
        this.pdfData.status = res.data.status
        this.state = res.data.status
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // async init() {
    //   if (this.activeTab == 0) {
    //     this.initData()
    //   }
    //   this.loading = false
    // },
    // async initData() {
    //   this.loading = true
    //   const obj1 = await this.libraryInit.state()
    //   this.state = obj1.status
    //   this.submitState = obj1.is_save
    //   // this.data1 = await this.libraryInit.data1()

    //   // this.data2 = await this.libraryInit.data2()
    //   // TODO:这里要判断this.state==3
    //   // this.data5 = await this.libraryInit.article({
    //   //   school_id: this.user.school_id
    //   // })
    //   // this.data3 = await this.libraryInit.data3({ type: 'img' })
    //   // this.data4 = await this.libraryInit.data3({ type: 'video' })
    //   // this.data6 = await this.libraryInit.data3({ type: 'report' })
    // },
    // contentStyle() {
    //   let height = this.state == 1 ? "750px" : "812px";
    //   return { height };
    // },
    // async handleApplyNext(v) {
    //   if (v.length == 6) {
    //     const obj = {}
    //     obj.data = v
    //     api.library.create.data(obj).then((res) => {
    //       if (!this.data3 && !this.data4) {
    //         this.$message.error('请上传图片资料和视频资料')
    //       } else if (!this.data3) {
    //         this.$message.error('请上传图片资料')
    //       } else if (!this.data4) {
    //         this.$message.error('请上传视频资料')
    //       } else {
    //         this.$message.success(
    //           '申报表保存成功!请根据申报申请流程，完成申报申请。'
    //         )
    //       }
    //       this.init()
    //     })
    //   } else {
    //     this.$message.error('请填写申报表')
    //   }
    // },
    async changeTab(x, y) {
      this.activeTab = x
      // this.init()
    },
    cancelSubmit() {
      this.$emit('input')
    }
  }
}
</script>
<style lang="scss" scoped>
.declare {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-tabs {
    margin-bottom: 10px;
    &-item {
      text-align: center;
      @include fun-design(7);
      line-height: 40px;
      width: 60px;
      cursor: pointer;
      margin-right: 30px;
    }
    .activeTab {
      @include fun-active();
    }
  }
  &-content {
    flex: 1;
    width: 100%;
    overflow: hidden;
    &>div{
      height: 100%;
    }
    section {
      height: 100%;
    }
  }
}

</style>
